<template>
    <div class="base-detail-card">
        <div class="base-title">
            <span v-if="!isExpand">{{title}}</span>
            <span 
                v-if="isExpand"
                @click="handleExpand" 
                class="base-title-box">
                <span>{{title}}</span>
                <img 
                    :class="['expand-icon',expandStatus==true?'packup-icon':'']"
                    src="../../assets/images/recharges-expand-icon@2x.png">
            </span>
        </div>
        <slot></slot>
    </div>
</template>

<script>

    export default {
        name:'base-detail-card',
        props:{
            title:{
                type:String,
                default:''
            },
            isExpand:{
                type:Boolean,
                default:false
            },
            accountExpand:{
                type:Boolean,
                default:false
            }
        },
        watch:{
            accountExpand:{
                handler(newVal){
                    this.expandStatus = newVal;
                }
            }
        },
        data(){
            return{
                expandStatus:false
            }
        },
        computed:{
            extraClasses () {
                return `base-detail-content-text`;
            },
        },
        methods:{
            handleExpand(){
                this.$emit('select-expand')
            }
        }
    }
</script>

<style lang="less" scoped>
.base-detail-card{
    padding: 24px;
    background-color: #fff;
    font-size: 0;

    .base-title{
        margin-bottom: 8px;
        font-weight: bold;
        color: #464C5B;
        font-size: 14px;
        .base-title-box{
            display: inline-block;
            font-size: 0;
            cursor: pointer;
            span{
                font-size: 14px;
            }
        }
        .expand-icon{
            width: 14px;
            height: 14px;
            margin-left: 8px;
            vertical-align: top;
            margin-top:4px;
        }
        .packup-icon{
            transform: rotate(180deg)
        }
    }
}
</style>
